import { Badge } from "flowbite-react";
export default Badge;
